var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('base-page',{attrs:{"title":"材料上传成功","content":"客服会尽快为您处理，请您耐心等待","pic":_vm.IMAGE_MAP.UPLOADED_PAGE_ICON}}),_c('view-progress',{attrs:{"mustLoggedOn":_vm.mustLoggedOn}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }